module.exports = __webpack_public_path__ + "static/img/curstage_1.60755612.png";